'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Object$keys = require('babel-runtime/core-js/object/keys')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsComponent = require('../../components/Component');

var _componentsComponent2 = _interopRequireDefault(_componentsComponent);

var _dbinfo = require('../../dbinfo');

var _dbinfo2 = _interopRequireDefault(_dbinfo);

var _constants = require('../../constants');

var Constants = _interopRequireWildcard(_constants);

var _componentsToolbar = require('../../components/Toolbar');

var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);

var _reactBootstrap = require('react-bootstrap');

var _reactisForms = require('reactis-forms');

var _reactisInputs = require('reactis-inputs');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactisModal = require('reactis-modal');

var _componentsFormDB = require('../../components/FormDB');

var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);

var _reactisLoader = require('reactis-loader');

var _componentsActionButton = require('../../components/ActionButton');

var _componentsActionButton2 = _interopRequireDefault(_componentsActionButton);

var _componentsSaveButton = require('../../components/SaveButton');

var _componentsSaveButton2 = _interopRequireDefault(_componentsSaveButton);

var _componentsFormClientLookup = require('../../components/Form/ClientLookup');

var _componentsFormClientLookup2 = _interopRequireDefault(_componentsFormClientLookup);

var _componentsFormUserLookup = require('../../components/Form/UserLookup');

var _componentsFormUserLookup2 = _interopRequireDefault(_componentsFormUserLookup);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _components = {
	_$WorkSubform: {
		displayName: 'WorkSubform'
	},
	_$Form: {
		displayName: 'Form'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var WorkSubform = (function (_React$Component) {
	_inherits(WorkSubform, _React$Component);

	function WorkSubform(props) {
		_classCallCheck(this, _WorkSubform);

		_React$Component.call(this, props);
		this.state = {
			overRemove: false
		};
	}

	WorkSubform.prototype.handleMouseOver = function handleMouseOver() {
		this.setState({ overRemove: true });
	};

	WorkSubform.prototype.handleMouseOut = function handleMouseOut() {
		this.setState({ overRemove: false });
	};

	WorkSubform.prototype.render = function render() {
		var _this = this;

		return _react2['default'].createElement(
			'tr',
			{ className: this.state.overRemove ? 'subformOverRemove' : null },
			_react2['default'].createElement(
				'td',
				null,
				_react2['default'].createElement(_reactisForms.FormField, { name: 'date' })
			),
			_react2['default'].createElement(
				'td',
				null,
				_react2['default'].createElement(_reactisForms.FormField, { name: 'time' })
			),
			_react2['default'].createElement(
				'td',
				null,
				_react2['default'].createElement('i', { title: 'Odstranit',
					onClick: this.props.onRemove,
					onMouseOver: function () {
						return _this.handleMouseOver();
					},
					onMouseOut: function () {
						return _this.handleMouseOut();
					},
					className: 'icon-cross removesubform' })
			)
		);
	};

	var _WorkSubform = WorkSubform;
	WorkSubform = _wrapComponent('_$WorkSubform')(WorkSubform) || WorkSubform;
	return WorkSubform;
})(_react2['default'].Component);

var Form = (function (_FormDB) {
	_inherits(Form, _FormDB);

	function Form(props, context) {
		_classCallCheck(this, _Form);

		_FormDB.call(this, props, context);

		this.api = {
			fetch: 'ticket.fetch',
			save: 'ticket.save',
			remove: 'ticket.delete'
		};

		this.changeEvent = 'ticket.change';

		this.messages = {
			remove: 'Opravdu si přejete požadavek odstranit?',
			notfound: 'Požadavek nenalezen!'
		};

		this.schema = {
			title: {
				'class': _reactisInputs.TextInput,
				label: 'Název',
				rules: {
					presence: { message: 'Předmět je povinná položka požadavku!' },
					length: {
						maximum: 255,
						message: 'Povolená délka předmětu je 255 znaků.'
					}
				}
			},
			client: {
				'class': _componentsFormClientLookup2['default'],
				label: 'Klient'
			},
			redmine_id: {
				'class': _reactisInputs.TextInput,
				label: 'Redmine #'
			},
			responsible: {
				'class': _componentsFormUserLookup2['default'],
				label: 'Řešitel'
			},
			text: {
				'class': _reactisInputs.CKEditor,
				label: 'Popis',
				height: 120,
				width: '100%',
				toolbar: [["Bold", "Italic", "-", "NumberedList", "BulletedList", "-", "Link", "Unlink"]]
			},
			/*created: {
   	class: DatePicker,
   	label: 'Dokončení do'
   },*/
			status: {
				'class': _reactisInputs.Select,
				options: _dbinfo2['default'].TicketStatus.asArray(),
				clearable: false,
				label: 'Stav',
				value: 1
			},
			archive: {
				'class': _reactisInputs.Checkbox,
				label: 'Archiv'
			},
			notice: {
				'class': _reactisInputs.TextArea,
				label: 'Poznámka',
				style: { height: '60px' }
			},
			items: {
				'class': _reactisForms.Multiform,
				label: 'Činnosti',
				addLabel: 'přidat činnost',
				value: [{ id: -1, date: new _moment2['default']().format('YYYY-MM-DD') }],
				subform: WorkSubform,
				showHeader: true,
				schema: {
					date: {
						'class': _reactisInputs.DatePicker,
						label: 'Datum',
						value: new _moment2['default']().format('YYYY-MM-DD')
					},
					time: {
						'class': _reactisInputs.TimeInput,
						label: 'Čas',
						style: { width: 55 },
						addonAfter: 'hh:mm'
					}
				}
			}

		};
		this.form = new _reactisForms.FormManager(this.schema);
	}

	Form.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		this.form.on('change', function (key, value) {
			if (key == 'title') {
				_this2.title = value;
			}
			_this2.changed = true;
		});
		_FormDB.prototype.componentDidMount.call(this);
	};

	Form.prototype.updateTab = function updateTab(data) {
		this.props.updateTab({ title: data.title });
	};

	Form.prototype.render = function render() {
		var _this3 = this;

		var loading = !!(this.props.form && this.props.form.get('loading'));

		var canEdit = true || this.user.isAllowed('user', 'update');
		var saveButton = _react2['default'].createElement(_componentsSaveButton2['default'], {
			disabled: !canEdit,
			loading: !!(this.props.form && this.props.form.get('saving')),
			onClick: function () {
				return _this3.save();
			}
		});

		var btns = _react2['default'].createElement(
			_reactBootstrap.ButtonToolbar,
			null,
			saveButton,
			this.props.id > 0 && _react2['default'].createElement(
				_componentsActionButton2['default'],
				{ disabled: !canEdit, bsStyle: 'danger', icon: 'fa fa-trash-o', onClick: function () {
						return _this3.remove();
					} },
				'Odstranit'
			)
		);

		return _react2['default'].createElement(
			'div',
			{ style: { position: 'relative' } },
			_react2['default'].createElement(_reactisLoader.Loader, { visible: !!(this.props.form && this.props.form.get('loading')) }),
			_react2['default'].createElement(
				_reactisForms.RxForm,
				{ ref: 'form', form: this.form, id: 'tab_' + this.props.tabid },
				_react2['default'].createElement(_componentsToolbar2['default'], { title: 'Požadavek', buttons: btns }),
				_react2['default'].createElement(
					'div',
					{ className: 'row' },
					_react2['default'].createElement(
						'div',
						{ className: 'col-md-6' },
						_react2['default'].createElement(
							'table',
							{ className: 'form' },
							_react2['default'].createElement(
								'tbody',
								null,
								_Object$keys(this.schema).filter(function (key) {
									return ['items'].indexOf(key) == -1;
								}).map(function (key) {
									return _react2['default'].createElement(_reactisForms.FormRow, { key: key, visible: _this3.schema[key].visible, name: key, labelWidth: '135' });
								}),
								_react2['default'].createElement(
									_reactisForms.FormRow,
									{ className: 'buttons' },
									saveButton
								)
							)
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: 'col-md-6' },
						_react2['default'].createElement(
							'table',
							{ className: 'form' },
							_react2['default'].createElement(
								'tbody',
								null,
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'items', labelWidth: '135' })
							)
						)
					)
				)
			)
		);
	};

	var _Form = Form;
	Form = _wrapComponent('_$Form')(Form) || Form;
	Form = _reactRedux.connect(function (state, props) {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	}, function (dispatch) {
		return { actions: _redux.bindActionCreators(_reactisForms.actions, dispatch) };
	}, null, { withRef: true })(Form) || Form;
	return Form;
})(_componentsFormDB2['default']);

exports['default'] = Form;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Ticket/Form.js
 ** module id = 994
 ** module chunks = 2
 **/